module.exports = __webpack_public_path__ + "static/media/BABYGROK-USDT.f24703d7.png";